export default __webpack_public_path__ + "static/media/explosion.min.d925f0f1.png";